var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"overlay"}},[_c('div',{staticClass:"center w-6/12"},[_c('div',{staticClass:"content border border-1 border-solid bg-white p-2 flex flex-col"},[_c('div',{staticClass:"text-gray-800 text-3xl my-auto"},[_vm._v("Give Access")]),_c('t-rich-select',{attrs:{"multiple":"","required":"","clearable":"","close-on-select":false,"options":_vm.options,"placeholder":"Add Users","value":_vm.selected,"classes":{
          wrapper: '',
          buttonWrapper: '',
          selectButton: 'bg-white border-gray-300',
          selectButtonLabel: '',
          selectButtonPlaceholder: 'text-gray-400',
          selectButtonIcon: 'text-gray-600',
          selectButtonClearButton: 'hover:bg-red-100 text-gray-600',
          selectButtonClearIcon: '',
          dropdown: 'bg-white border-gray-300',
          dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
          loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
          optionsList: '',
          searchWrapper: 'p-2 placeholder-gray-400',
          searchBox:
            'px-3 py-2 bg-gray-50 text-sm rounded border focus:outline-none focus:outline-none border-gray-300',
          optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
          option: '',
          disabledOption: '',
          highlightedOption: 'bg-red-100',
          selectedOption:
            'font-semibold bg-gray-100 bg-woo font-semibold text-white',
          selectedHighlightedOption:
            'font-semibold bg-gray-100 bg-woo font-semibold text-white',
          optionContent: 'flex justify-between items-center px-3 py-2',
          optionLabel: '',
          selectedIcon: '',
          enterClass: 'opacity-0',
          enterActiveClass: 'transition ease-out duration-100',
          enterToClass: 'opacity-100',
          leaveClass: 'opacity-100',
          leaveActiveClass: 'transition ease-in duration-75',
          leaveToClass: 'opacity-0',
        }}}),_c('div',{staticClass:"w-full justify-end p-3 flex cursor-default"},[_c('div',{staticClass:"flex flex-row",staticStyle:{"width":"300px"}},[_c('button',{staticClass:"m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs",attrs:{"disabled":_vm.selected.length == 0},on:{"click":_vm.submit}},[_vm._v(" Add ")]),_c('button',{staticClass:"m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Close ")])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }